import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AlertServiceService } from './../api-module/services/alertservice/alert-service.service';
import { AlertComponentComponent } from './shared/alert-component/alert-component.component';
import { FooterComponentComponent } from './footer-component/footer-component.component';
import { MainHeaderComponentComponent } from './main-header-component/main-header-component.component';
import { ApiModuleModule } from './../api-module/api-module.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, Type } from '@angular/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DataViewModule } from 'primeng/dataview';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { SplitButtonModule } from 'primeng/splitbutton';
// import { FileUploadModule } from 'primeng/components/fileupload/fileupload';
// import { ProgressSpinnerModule } from 'primeng/components/progressspinner/progressspinner';
// import { TooltipModule } from 'primeng/components/tooltip/tooltip';
// import { InputSwitchModule } from 'primeng/components/inputswitch/inputswitch';
// import { DropdownModule } from 'primeng/components/dropdown/dropdown';
// import { MultiSelectModule } from 'primeng/components/multiselect/multiselect';
// import { SelectButtonModule } from 'primeng/components/selectbutton/selectbutton';
import { DragulaModule } from "ng2-dragula";
// import { DataTableModule } from 'primeng/components/datatable/datatable';
// import { SharedModule } from 'primeng/components/common/shared';
import { DateFromToComponent } from './date-from-to/date-from-to.component';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TabViewModule } from 'primeng/tabview';
import { NotificationModalComponent } from './shared/notification-modal/notification-modal.component';
import { NotificationListComponent } from './shared/notification-list/notification-list.component';
import { ListboxModule } from 'primeng/listbox';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../../environments/environment';
import { PageTitleComponent } from './shared/page-title/page-title.component';
import { HoursToHoursMinutesSecondsPipe } from './shared/hours-to-hours-minutes-seconds.pipe';
import { ToastModule } from 'primeng/toast';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { KeyFilterModule } from 'primeng/keyfilter';
import { InputRestrictionDirective } from './input-restriction.directive';
// import { SidebarModule, ScheduleModule, CheckboxModule, RadioButtonModule } from 'primeng/primeng';
// import { GrowlModule } from 'primeng/primeng';
import { OrderFilterComponent } from '../dispatcher/order-filter/order-filter.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatMenuModule } from '@angular/material/menu';
import { ConfirmationDialog } from './confirm-dialog-component/confirm-dialog-component';
import { NoSpacesAllowedDirective } from './no-space-allowed.directive';
import { PreventClickByEnterDirective } from './prevent-click-by-enter.directive';
import { CustomerAddressComponent } from './customer-address/customer-address.component';
import { SearchAddressComponent } from './search-address/search-address.component';
import { MatButtonModule, MatCardModule, MatDialogModule, MatIconModule } from '@angular/material';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FileService } from '../api-module/services/file.service';
import { ViewInvoiceDetailComponent } from '../contracts-management/contractDeatail/view-invoice-detail/view-invoice-detail.component';
import { PermissionDirective } from './permissions/permission.directive';
import { YouDontHavePermissionComponent } from './permissions/you-dont-have-permission/you-dont-have-permission.component';
import { NotPermissionDirective } from './permissions/not-permission.directive';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { ToLocalDatePipe } from '../pips/ToLocalDatePipe';
import { ExportingConfirmationDialogComponent } from '../contracts-management/exporting-confirmation-dialog/exporting-confirmation-dialog.component';
import { HasAllPermissionsDirective } from './permissions/has-all-permissions.directive';
import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { ManualInvoicePaymentTransactionComponent } from './manual-invoice-payment-transaction/manual-invoice-payment-transaction.component';
import { AtLeasthasNPermissionsDirective } from './permissions/at-least-has-n-permissions.directive';
import { ConfirmationDialogWWithReason } from './confirm-dialog-with-reason-component/confirm-dialog-with-reason-component';
import { CurrencyDirective } from './Currency.directive';
import { CloseMenuOnScrollDirective } from './close-menu-on-scroll.directive';
import { RecieveCallAlertComponentComponent } from './shared/recieve-call-alert-component/recieve-call-alert-component';
import { LocationsTableComponent } from './locations-table/locations-table.component';
import { EditLocationsTableComponent } from './edit-locations-table/edit-locations-table.component';
import { EditLocationsTableRenewContractComponent } from './edit-locations-table-renew-contract/edit-locations-table-renew-contract.component';
import { UploadComponent } from './upload/upload.component';
import { ViewLocationsTableComponent } from './view-locations-table/view-locations-table.component';
import { ConfigurationDirective } from './shared/quotation-configuration.directive';
import { SingleSearchAddressComponent } from './single-search-address/single-search-address.component';
import { MulipleSearchAddressComponent } from './shared/muliple-search-address/muliple-search-address.component';
import { ExportingConfirmationEmailDialogComponent } from '../contracts-management/exporting-confirmation-email-dialog/exporting-confirmation-email-dialog.component';
import { ConfirmDialogExpiredEditingComponent } from './confirm-dialog-expired-editing/confirm-dialog-expired-editing.component';
import{ExactSearchComponent} from  './exact-search/exact-search.component'
import { ConfirmCustomerPhonesComponent } from '../contracts-management/confirm-customer-phones/confirm-customer-phones.component';
import { CustomSpinnerComponent } from './custom-spinner/custom-spinner.component';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SharedModule } from 'primeng/api';
import { SelectButtonModule } from 'primeng/selectbutton';
import { MultiSelectModule } from 'primeng/multiselect';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TooltipModule } from 'primeng/tooltip';
import { FileUploadModule } from 'primeng/fileupload';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { InputSwitchModule } from 'primeng/inputswitch';
import { SidebarModule } from 'primeng/sidebar';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { WhitespaceDirective } from './directives/whitespace.directive';


@NgModule({
  imports: [
    ConfirmDialogModule,
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    DragulaModule,
    ApiModuleModule,
    FormsModule,
    NgxDatatableModule,
    TooltipModule,
     SplitButtonModule,
    CalendarModule,
    // GrowlModule,
    AccordionModule,
    MessagesModule,
    MessageModule,
    FileUploadModule,
    ProgressSpinnerModule,
     InputSwitchModule,
    DropdownModule,
    // DataTableModule,
    TableModule,
     SharedModule,
    MultiSelectModule,
    SelectButtonModule,
    ToggleButtonModule,
    TabViewModule,
    DataViewModule,
    ListboxModule,
    ToastModule,
    CheckboxModule,
    RadioButtonModule,
    NgbModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,
    ScrollingModule,
    InfiniteScrollModule,
    KeyFilterModule,
    SidebarModule,
    // ScheduleModule,
    TranslateModule,
    MatMenuModule,
    MatDialogModule,
    FontAwesomeModule,
    MatCardModule,
    NgxQRCodeModule,
    MatIconModule,
    MatButtonModule
  ],
  declarations: [
    RecieveCallAlertComponentComponent,
    ToLocalDatePipe,
    MainHeaderComponentComponent,
    FooterComponentComponent,
    AlertComponentComponent,
    RecieveCallAlertComponentComponent,
    DateFromToComponent,
    ConfirmationDialog,
    ConfirmationDialogWWithReason,
    NotificationModalComponent,
    NotificationListComponent,
    PageTitleComponent,
    HoursToHoursMinutesSecondsPipe,
    InputRestrictionDirective,
    OrderFilterComponent,
    NoSpacesAllowedDirective,
    PreventClickByEnterDirective,
    CustomerAddressComponent,
    SearchAddressComponent,
    ViewInvoiceDetailComponent,
    PermissionDirective,
    NotPermissionDirective,
    YouDontHavePermissionComponent,
    ExportingConfirmationDialogComponent,
    HasAllPermissionsDirective,
    ManualInvoicePaymentTransactionComponent,
    AtLeasthasNPermissionsDirective,
    CurrencyDirective,
    CloseMenuOnScrollDirective,
    LocationsTableComponent,
    EditLocationsTableComponent,
    EditLocationsTableRenewContractComponent,
    UploadComponent,
    ViewLocationsTableComponent,
    ConfigurationDirective,
    SingleSearchAddressComponent,
    MulipleSearchAddressComponent,
    ExportingConfirmationEmailDialogComponent,
    ConfirmDialogExpiredEditingComponent,
    ExactSearchComponent,
    ConfirmCustomerPhonesComponent,
    
    CustomSpinnerComponent,
          WhitespaceDirective

  ],
  exports: [
    WhitespaceDirective,
    RecieveCallAlertComponentComponent,
    ToLocalDatePipe,
    CommonModule,
    ReactiveFormsModule,
    ListboxModule,
    ToggleButtonModule,
    MainHeaderComponentComponent,
    FooterComponentComponent,
    AlertComponentComponent,
    RecieveCallAlertComponentComponent,
    NgxDatatableModule,
    NgbModule,
    ApiModuleModule,
    TooltipModule,
    SplitButtonModule,
    CalendarModule,
    // GrowlModule,
    AccordionModule,
    MessagesModule,
    MessageModule,
    FileUploadModule,
    ProgressSpinnerModule,
    DragulaModule,
    FormsModule,
    InputSwitchModule,
    // DataTableModule, 
    TableModule,
    SharedModule,
    DropdownModule,
    MultiSelectModule,
    DateFromToComponent,
    ConfirmationDialog,
    ConfirmationDialogWWithReason,
    SelectButtonModule,
    NotificationModalComponent,
    DataViewModule,
    HoursToHoursMinutesSecondsPipe,
    ToastModule,
    CheckboxModule,
    RadioButtonModule,
    AngularFireModule,
    AngularFireMessagingModule,
    PageTitleComponent,
    ScrollingModule,
    InfiniteScrollModule,
    KeyFilterModule,
    InputRestrictionDirective,
     SidebarModule,
    // ScheduleModule,
    OrderFilterComponent,
    NoSpacesAllowedDirective,
    PreventClickByEnterDirective,
    CustomerAddressComponent,
    SearchAddressComponent,
    MatMenuModule,
    MatDialogModule,
    TabViewModule,
    ViewInvoiceDetailComponent,
    MatCardModule,
    PermissionDirective,
    NotPermissionDirective,
    YouDontHavePermissionComponent,
    ExportingConfirmationDialogComponent,
    HasAllPermissionsDirective,
    ManualInvoicePaymentTransactionComponent,
    AtLeasthasNPermissionsDirective,
    CurrencyDirective,
    CloseMenuOnScrollDirective,
    LocationsTableComponent,
    EditLocationsTableComponent,
    EditLocationsTableRenewContractComponent,
    UploadComponent,
    ViewLocationsTableComponent,
    ConfigurationDirective,
    SingleSearchAddressComponent,
    MulipleSearchAddressComponent,
    ExportingConfirmationEmailDialogComponent,
    ConfirmDialogExpiredEditingComponent,
    ExactSearchComponent,
    ConfirmCustomerPhonesComponent,
    
    CustomSpinnerComponent ,ConfirmDialogModule
  ],
  entryComponents: [
    NotificationModalComponent,
    ConfirmationDialog,
    ConfirmationDialogWWithReason,
    ViewInvoiceDetailComponent,
    YouDontHavePermissionComponent,
    ExportingConfirmationDialogComponent,
    CustomerAddressComponent,
    ExportingConfirmationEmailDialogComponent,
    ConfirmDialogExpiredEditingComponent,
    ConfirmCustomerPhonesComponent

  ]
})

export class SharedModuleModule {

  static forRoot(entryComponents?: Array<Type<any> | any[]>): ModuleWithProviders<SharedModuleModule> {
    return {
      ngModule: SharedModuleModule,
      providers: [
        AlertServiceService,
        FileService,
        ToLocalDatePipe , ConfirmationService
      ]
    };
  }
}

export const rootShared: ModuleWithProviders<SharedModuleModule> = SharedModuleModule.forRoot();
